import React from "react";

const DeleteIcon = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99023 14.5566C2.01953 15.2891 2.66406 15.875 3.39648 15.875H10.5742C11.3066 15.875 11.9512 15.2891 11.9805 14.5566L12.625 4.625H1.375L1.99023 14.5566ZM13.0938 1.8125H9.8125L9.46094 1.13867C9.37305 0.992188 9.22656 0.875 9.05078 0.875H4.91992C4.74414 0.875 4.59766 0.992188 4.50977 1.13867L4.1875 1.8125H0.90625C0.642578 1.8125 0.4375 2.04688 0.4375 2.28125V3.21875C0.4375 3.48242 0.642578 3.6875 0.90625 3.6875H13.0938C13.3281 3.6875 13.5625 3.48242 13.5625 3.21875V2.28125C13.5625 2.04688 13.3281 1.8125 13.0938 1.8125Z"
        fill="#FF9999"
      />
    </svg>
  );
};

export default DeleteIcon;
